import { DATE_RELATIONS } from '@frontend/api';

export const DATE_RANGE_DATE_RELATIONS = [DATE_RELATIONS.BETWEEN] as const;
